import React from 'react';
import PropTypes from 'prop-types';

const MiscSnippet = ({ name }) => {
  switch (name) {
    case 'divewire_content_policy':
      return (
        <div className="content-policy-wrapper" style={{ marginBottom: '16px' }}>
          <div className="message message--warning" style={{ marginBottom: '0.5rem' }}>
            <h3 className="content-policy-wrapper__title">The DiveWire Content Policy</h3>
            <p className="content-policy-wrapper__text">
              DiveWire only allows company news announcements in the format of a press release
              to be published through the self-serve platform. The DiveWire team reviews each
              post to ensure they adhere to&nbsp;
              <a
                href="https://www.industrydive.com/divewire-content-policy/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <strong>
                  The DiveWire Content Policy
                </strong>
              </a>.
              Industry Dive reserves the right to remove any self-published article or
              advertisement without refund or credit. Before submitting your announcement
              please ensure your press release meets the guidelines.
            </p>
          </div>
        </div>
      );
    default:
      return (<></>);
  }
};

MiscSnippet.propTypes = {
  name: PropTypes.string.isRequired,
};

export default MiscSnippet;
